import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../components/Modal';
import Text, { TextType } from '../../../../components/Text';
import Image, { ImageDataType } from '../../../../components/Image';
import Button from '../../../../components/Button';

import './ReferralInfoModal.scss';

const className = 'c-ReferralInfoModal';

const ReferralInfoModal = ({
  title,
  imgSrc,
  description,
  disclaimer,
  ctaLabel,
  open,
  onClose,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    customContainerClass={`${className}__custom-modal-container`}
  >
    <div className={className}>
      <Image {...imgSrc} />

      <div className={`${className}__title`}>
        <Text text={title} />
      </div>

      <p className={`${className}__description`}>{description}</p>
      <p className={`${className}__disclaimer`}>{disclaimer}</p>

      <Button onClick={onClose} displayType="primary" newVersion={true}>
        {ctaLabel}
      </Button>
    </div>
  </Modal>
);

export const ReferralInfoModalPropTypes = {
  title: TextType,
  imgSrc: ImageDataType,
  description: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ReferralInfoModal.propTypes = ReferralInfoModalPropTypes;

export default ReferralInfoModal;
